import React, { useState } from 'react';
import CareerHeader from '../../components/Career/Default/CareerHeader';
import MyResumes from '../../components/Career/Default/MyResumes';
import HeroBottom from '../../components/Career/Default/HeroBottom';
import { Toast, useT } from '@repo/common';

const Career = () => {
  const t = useT();
  const [standardToastKey, setStandardToastKey] = useState(0);
  const [deleteToastKey, setDeleteToastKey] = useState(0);
  const [standardToastShow, setStandardToastShow] = useState(false);
  const [deleteToastShow, setDeleteToastShow] = useState(false);

  const handleStandardSuccess = () => {
    setStandardToastKey((prev) => prev + 1);
    setStandardToastShow(true);
  };

  const handleDeleteSuccess = () => {
    setDeleteToastKey((prev) => prev + 1);
    setDeleteToastShow(true);
  };

  return (
    <div className='bg-grayscale-gray01 pb-[160px] tabletH:pb-[240px]'>
      <CareerHeader />
      <MyResumes
        onStandardSuccess={handleStandardSuccess}
        onDeleteSuccess={handleDeleteSuccess}
      />
      <HeroBottom />

      {standardToastShow && (
        <div
          key={standardToastKey}
          className='fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000]'
        >
          <Toast
            title={t('Standard resume set', '대표 이력서로 설정되었습니다')}
            customWidth='280px'
          />
        </div>
      )}

      {deleteToastShow && (
        <div
          key={deleteToastKey}
          className='fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000]'
        >
          <Toast
            title={t('Resume deleted', '이력서가 삭제되었습니다')}
            customWidth='240px'
          />
        </div>
      )}
    </div>
  );
};

export default Career;
